'use client';
import React from 'react';

export default function HealthiestSelfSection() {
  return (
    <section
      className="relative w-full overflow-hidden"
      style={{ backgroundColor: '#DFD0CC', paddingTop: 'clamp(72px, 9vw, 128px)', paddingBottom: 'clamp(72px, 9vw, 128px)' }}
    >
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 clamp(24px, 4vw, 64px)' }}>
        <div className="flex flex-col lg:flex-row items-start lg:items-center gap-12 lg:gap-20">

          {/* Left: heading */}
          <div style={{ flex: '1 1 0' }}>
            <p
              style={{
                fontFamily: 'adobe-garamond-pro, Georgia, serif',
                fontSize: '11px',
                letterSpacing: '0.16em',
                textTransform: 'uppercase',
                color: '#8A9E8C',
                marginBottom: '20px',
              }}
            >
              Enquiries
            </p>
            <h2
              style={{
                fontFamily: 'orpheus-pro, Georgia, serif',
                fontSize: 'clamp(26px, 3.5vw, 52px)',
                fontWeight: '400',
                color: '#1A2332',
                lineHeight: '1.2',
                fontStyle: 'normal',
              }}
            >
              Get in touch
            </h2>
          </div>

          {/* Right: copy + CTA */}
          <div style={{ flex: '0 0 auto', maxWidth: '400px' }}>
            <p
              style={{
                fontFamily: 'adobe-garamond-pro, Georgia, serif',
                fontSize: 'clamp(15px, 1.2vw, 18px)',
                color: '#4A4A4A',
                lineHeight: '1.75',
                marginBottom: '32px',
              }}
            >
              If you would like to discuss working together or enquire about any of the services offered, please feel free to get in touch. All enquiries are handled with complete confidentiality.
            </p>
            <a
              href="/contact"
              style={{
                fontFamily: 'adobe-garamond-pro, Georgia, serif',
                fontSize: '13px',
                letterSpacing: '0.12em',
                textTransform: 'uppercase',
                color: '#EFE3E1',
                backgroundColor: '#1A2332',
                padding: '15px 36px',
                textDecoration: 'none',
                display: 'inline-block',
                transition: 'background-color 0.25s ease',
              }}
              onMouseEnter={e => ((e.currentTarget as HTMLElement).style.backgroundColor = '#2C2C2C')}
              onMouseLeave={e => ((e.currentTarget as HTMLElement).style.backgroundColor = '#1A2332')}
            >
              Make an Enquiry
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
